// extracted by mini-css-extract-plugin
module.exports = {"root":"header-wrapper_root__33kgA","innerRoot":"header-wrapper_innerRoot__7ssDT","searchPage":"header-wrapper_searchPage__L7qK8"};